/* NSL — automotive motion system (CSS/SVG/Canvas). transform+opacity only, prefers-reduced-motion aware. */
(function(){
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal — "headlight sweep" as sections enter */
  function reveal(){
    var els = document.querySelectorAll('.reveal');
    if(!els.length) return;
    if(reduce){ els.forEach(function(e){e.classList.add('in');}); return; }
    var io = new IntersectionObserver(function(en){
      en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('in'); io.unobserve(x.target); } });
    },{rootMargin:'0px 0px -8% 0px',threshold:.12});
    els.forEach(function(e){io.observe(e);});
  }

  /* Tachometer count-up */
  function counters(){
    var els = document.querySelectorAll('[data-count]');
    if(!els.length) return;
    var io = new IntersectionObserver(function(en){
      en.forEach(function(x){
        if(!x.isIntersecting) return;
        var el=x.target, end=parseInt(el.dataset.count,10),
            pre=el.dataset.prefix||'', suf=el.dataset.suffix||'', t0=performance.now(), dur=1400;
        if(reduce){ el.textContent=pre+end.toLocaleString()+suf; io.unobserve(el); return; }
        (function tick(now){
          var p=Math.min((now-t0)/dur,1), e=1-Math.pow(1-p,3);
          el.textContent=pre+Math.round(e*end).toLocaleString()+suf;
          if(p<1) requestAnimationFrame(tick);
        })(t0);
        io.unobserve(el);
      });
    },{threshold:.4});
    els.forEach(function(e){io.observe(e);});
  }

  /* Header suspension drop on scroll */
  function header(){
    var h=document.querySelector('.site-header'); if(!h) return;
    var f=function(){ h.toggleAttribute('data-scrolled', window.scrollY>30); };
    f(); window.addEventListener('scroll',f,{passive:true});
  }

  /* Hero "road dust" — cheap canvas particles drifting like airflow */
  function roadDust(){
    var host=document.getElementById('road-dust'); if(!host||reduce) return;
    var c=document.createElement('canvas'), x=c.getContext('2d');
    host.appendChild(c); var W,H,dots=[];
    function size(){ W=c.width=host.offsetWidth; H=c.height=host.offsetHeight; }
    size(); window.addEventListener('resize',size);
    for(var i=0;i<46;i++) dots.push({x:Math.random()*W,y:Math.random()*H,s:.4+Math.random()*1.4,v:.3+Math.random()*1.1});
    (function loop(){
      x.clearRect(0,0,W,H);
      for(var i=0;i<dots.length;i++){var d=dots[i]; d.x+=d.v; if(d.x>W+4){d.x=-4;d.y=Math.random()*H;}
        x.fillStyle='rgba(230,126,34,'+(0.05+d.s*0.06)+')'; x.fillRect(d.x,d.y,d.s*2,d.s);}
      requestAnimationFrame(loop);
    })();
  }

  function init(){ reveal(); counters(); header(); roadDust(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
